export default __webpack_public_path__ + "static/media/announcement-icon.6e9403b9.svg";